<template>
  <div class="quoteFilterInfo">
    <ul class="qfi-list">
      <li
        v-for="(item, index) in infoList"
        v-show="!item.isHide"
        :key="index + 'qfi-item'"
        class="qfi-item"
      >
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {filterName, toThousands} from '@/utils/commonUse'
import MixinOptions from '@/mixins/options'

export default {
  name: 'quoteFilterInfo',
  mixins: [MixinOptions],
  props: {
    classId: {
      default: ''
    },
    localAllOptions: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    isShowFilter: {
      type: Boolean,
      default: false
    },
    isShowPcyCmntDt: {
      type: Boolean,
      default: false
    },
    isElectricCar11: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      PopType : '',
      popVisible : false,
    }
  },
  computed: {
    ...mapState('quote', [
      'quoteForm','carModelOptions'
    ]),
    ...mapState('common', ['productId']),
    infoList(){
      if(this.productId == 11){
        return this.carInfoList
      }else if(this.classId == 26||this.classId==29){
        return this.homeInfoList
      }else if(this.classId == 21){
        return this.housemaidInfoList
      }
      else if(this.classId == 25){
        return this.studentInfoList
      }
      else if(this.classId == 27){
        return this.personalInfoList
      }
      else if(this.classId == 24){
        return this.deocrationInfoList
      }
      else{
        let list = []
        const obj = this.quoteForm
        const optObj = this.localAllOptions
        // plan_type
        Object.keys(obj).forEach(key=>{
          if(this.isSpecialKey(key)){
            let name = this.specialName(key)
            name && list.push({
              label : name
            })
          }else if(optObj[key]){
            let name = filterName(obj[key],'id',optObj[key])
            name && list.push({
              label : name
            })
          }
        })
        return list
      }
    },
    carInfoList() {
      const {
        nm_drvr_list,
        class_id,
        usage_ind,
        brand_id,
        typ_of_bdy_id,
        typ_of_bdy_mix_id,
        engn_cpcty,
        rgtn_yr,
        ncd_pct,
        model_id,
        model,
        isrd_vl,
        no_of_nm_drvr } = this.quoteForm
      let list = []
      if(class_id == 14) {
        const drvrAge = nm_drvr_list && nm_drvr_list[0] && nm_drvr_list[0].nm_drvr_age ? nm_drvr_list[0].nm_drvr_age : ''
        list = [
          ...list,
          {
            label: this.getAllOptionName('rgtn_yr', rgtn_yr, class_id )
          },
          {
            label: this.getOptionName('usageOptions', usage_ind )
          },
          {
            label: this.getAllOptionName('typ_of_bdy', typ_of_bdy_id, class_id )
          },
          {
            label: `${engn_cpcty||0} cc` ,
          },
          // {
          //   label: drvrAge ? drvrAge + ' ' + 'years old' : ''
          // },
          {
            label: no_of_nm_drvr ? no_of_nm_drvr + ' ' + 'Driver(s)' : ''
          },
        ]
      }
      else if(class_id == 11) {
        list = [
          ...list,
          {
            label: this.getAllOptionName11('brand', brand_id)
          },
          {
            label: this.getOptionName('carModelOptions', model_id) || model || ''
          },
          {
            label: this.getAllOptionName('typ_of_bdy', typ_of_bdy_id, class_id ),
            isHide: typ_of_bdy_id ? false : true
          },
          {
            label: engn_cpcty ? engn_cpcty + 'cc' : '',
            isHide: this.isElectricCar11
          },
          {
            label: this.getAllOptionName('rgtn_yr', rgtn_yr, class_id )
          },
          {
            label: no_of_nm_drvr ? no_of_nm_drvr + ' ' + 'Driver(s)' : ''
          },
          {
            label: `HK$ ${toThousands(isrd_vl)}`,
            isHide: isrd_vl ? false : true
          }
        ]
      }
      else if(class_id == 12) {
        // let tonnge =
        list = [
          ...list,
          {
            label: this.getAllOptionName('typ_of_mix', typ_of_bdy_mix_id, class_id )
          },
          {
            label: this.getAllOptionName12('brand', brand_id, class_id )
          },
          {
            label: this.getAllOptionName('rgtn_yr', rgtn_yr, class_id )
          },
          {
            label: 1 + ' ' + 'Driver(s)'
          },
          {
            label: `HK$ ${toThousands(isrd_vl)}`,
            isHide: isrd_vl ? false : true
          }
        ]
      }
      // 轉大寫

      // list.map(item => {
      //   item.label =  String(item.label).toUpperCase()
      //   return item
      // })
      return list
    },
    houseMaidIsDoula(){
      const { duty_id } = this.quoteForm
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula == 1
    },
    housemaidInfoList(){
      const { duty_id, nature, nationality_id, domestic_age, period_of_cvr, monthly_salary, coverage_id } = this.quoteForm

      return [
        {
          label: this.getAllOptionName21('duties', duty_id )
        },
        {
          label: this.getAllOptionName21('nature', nature, this.classId )
        },
        {
          label: this.getAllOptionName21('nationality_show', nationality_id)
        },
        {
          label: this.getAllOptionName21('domestic_age', domestic_age) + ' years old',
        },
        {
          label: monthly_salary ? `HK$ ${toThousands(monthly_salary)}` : '',
        },
        {
          label: this.getAllOptionName21('period', period_of_cvr, this.classId ),
          isHide: this.houseMaidIsDoula
        },
        {
          label: this.getAllOptionName21('coverage', coverage_id, this.classId ),
          isHide: this.houseMaidIsDoula
        },

      ]
    },
    homeInfoList(){
      const { prop_insured, bldg_typ, floor_area, coverage_id, bsc_sum_insured, prop_age } = this.quoteForm
      const hasSumBuildingStructure = [2, 3].includes(coverage_id)
      return [
        {
          label: this.getAllOptionName26('prop_insured', prop_insured, this.classId )
        },
        {
          label: this.getAllOptionName26('bldg_types', bldg_typ, this.classId )
        },
        {
          label: floor_area ? `${floor_area} sq. ft.` : '',
        },
        {
          label: this.getAllOptionName26('coverage', coverage_id, this.classId ),
          isHide : this.classId==29
        },
        {
          label: bsc_sum_insured ? `HK$ ${toThousands(bsc_sum_insured)}` : '',
          isHide : !hasSumBuildingStructure
        },
        {
          label: this.getAllOptionName26('prop_age', prop_age, this.classId )
        },
      ]
    },
    fireInfoList(){
      const { prop_insured, bldg_typ, floor_area, coverage_id, bsc_sum_insured, prop_age } = this.quoteForm
      const hasSumBuildingStructure = [2, 3].includes(coverage_id)
      return [
        {
          label: this.getAllOptionName26('prop_insured', prop_insured, this.classId )
        },
        {
          label: this.getAllOptionName26('bldg_types', bldg_typ, this.classId )
        },
        {
          label: floor_area ? `${floor_area} sq. ft.` : '',
        },
        {
          label: this.getAllOptionName26('coverage', coverage_id, this.classId )
        },
        {
          label: bsc_sum_insured ? `HK$ ${toThousands(bsc_sum_insured)}` : '',
          isHide : !hasSumBuildingStructure
        },
        {
          label: this.getAllOptionName26('prop_age', prop_age, this.classId )
        },
      ]
    },
    studentInfoList(){
      const { country_id, student_age } = this.quoteForm
      return [
        {
          label: this.getAllOptionName25('study_country', country_id)
        },
        {
          label: student_age+ 'years old'
        }
      ]
    },
    traveller(){
      const { class_type, no_of_traveler, no_of_adult, no_of_child, plan_type,no_of_senior } = this.quoteForm
      const signAdult = 'Adult(s)'
      const signSenior = 'Elderly'
      const signChild = 'Child(ren)'
      let child = no_of_child?`${no_of_child} ${signChild}`:''
      let senior = no_of_senior?`${no_of_senior} ${signSenior}  `:''
      let adult = no_of_adult?`${no_of_adult} ${signAdult} `:''
      let all_text = `${senior} ${adult} ${child}`
      return all_text
    },
    personalInfoList(){
      const { occ_id, age_id,type_of_insured } = this.quoteForm
      let person = [
        {
          label: this.getAllOptionName27('type_of_insured',type_of_insured)
        },
        {
          label: age_id +'years old'
        },
        {
          label: this.getAllOptionName27('occupation', occ_id)
        }
      ]
      let family = [
        {
          label: this.getAllOptionName27('type_of_insured', type_of_insured)
        },
        {
          label: this.traveller
        }
      ]
      return type_of_insured==1?person:family
    },
    deocrationInfoList(){
      const { tol_contr_sum, tppd_limit_amt,contr_prd,bldg_ages} = this.quoteForm
      return [
        {
          label: `HK$ ${toThousands(tol_contr_sum)}`,
        },
        {
          label: this.getAllOptionName24('period', contr_prd)
        },
        {
          label: this.getAllOptionName24('bldg_ages', bldg_ages)
        },
      ]
    },
    isFamily() {
      const { class_type , plan_type} = this.quoteForm
      if(plan_type == 4) return true
      return class_type == 3
    },
    isSingle(){
      const { plan_type } = this.quoteForm
      return plan_type == 1 || plan_type == 3
    },
    isEasyGo(){
      let {plan_type} =this.quoteForm||{}
      return plan_type == 5
    },
  },
  mounted () {
  },
  methods: {
    gotoQuickQuote(){
      // this._globalRouterReplace({
      //   path: `/insurance/${classIdQuickQuoteProductPath[this.classId]}`,
      //   query: this.$route.query
      // })
    },
    handleEdit(){
      if(this.productId == 11){
        this.gotoQuickQuote()
      }else{
        this.ShowPop('filterPop')
      }
    },
    isSpecialKey(key){
      const keyObj = {
        23 : ['class_type','no_of_traveler','pcy_cmnt_dt','pcy_expry_dt','area_of_travel'],
        25 : ['student_age','country_id'],
        27 : ['age_id','country_id']
      }
      return keyObj[this.classId] && keyObj[this.classId].includes(key)
    },
    specialName(key){
      const optObj = this.localAllOptions
      const date = this.quoteForm
      const isOneDayLocalTour = date['plan_type'] == 4
      if(key == 'pcy_cmnt_dt'){
        if(isOneDayLocalTour) return `${date.pcy_cmnt_dt}`
        return this.isShowPcyCmntDt ? `${date.pcy_cmnt_dt} - ${date.pcy_expry_dt}` : ''
      }else if(key == 'class_type'){

        const sign = ''
        const signAdult = 'Adult(s)'
        const signSenior = 'Elderly'
        const signChild = 'Child(ren)'
        const Nochild = Number(date.no_of_child)
        const Noadult = Number(date.no_of_adult)
        const Nosenior = Number(date.no_of_senior)
        let peopleNum = this.isFamily ? (Noadult + Nochild + Nosenior) : Number(date.no_of_traveler)
        let travelers = Number(peopleNum)

        const showKey = {
          no_of_senior : Nosenior ? `${Nosenior} ${signSenior}` : '',
          no_of_adult : Noadult ? `${Noadult} ${signAdult}` : '',
          no_of_child : Nochild ? `${Nochild} ${signChild}` : '',
        }

        if(this.isFamily || this.isSingle||this.isEasyGo){
          let arr = []
          Object.keys(showKey).forEach((key)=>{
            if(showKey[key]){
              arr.push(showKey[key])
            }
          })
          return arr.join(' · ')
        }else{
          return `${travelers} ${signAdult}`
        }
      }else if(key == 'area_of_travel'){
        let name = filterName(date[key],'id',optObj[key])
        return isOneDayLocalTour ? '' : name
      }
      return ''
    },
    ShowPop(type){
      this.PopType = type
      this.popVisible = true
    },
  }
}
</script>

<style scoped lang="scss">
.quoteFilterInfo{
  position: relative;
  background: #FFFFFF;
  //border-radius: 25px;
  //padding:0 0 20px 0;
  .qfi-title{
    padding-right: 20px;
  }
  .EditBtn{
    position: absolute;
    top: 18px;
    right: 10px;
  }
  .qfi-list{
    padding-top: 4px;
    margin-left: -12px;
    .qfi-item{
      display: inline-block;
      vertical-align: top;
      margin-left: 12px;
      margin-bottom: 12px;
      background: rgba(209, 213, 218, 0.5);
      border-radius: 38px;
      font-weight: 500;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      color: #24292E;
      text-align: center;
      padding: 0 12px;
    }
  }
}
</style>
